import { useEffect } from 'react';
import useAuth from 'hooks/useAuth';
import Api from 'utils/api';

const AutoAuthByToken = () => {
    const { authorize, setAsGuest } = useAuth();

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            authorize(token);
        } else {
            setAsGuest();
        }

        Api.subscribe('onError401', () => {
            localStorage.removeItem('token');
            window.location.reload();
        });
        // eslint-disable-next-line
    }, []);

    return null;
};

export default AutoAuthByToken;
